export default function AdminDashboard() {
  return (
    <div className="admin-dashboard">
      <h1 className="admin-page-title">Witaj w panelu administracyjnym!</h1>
      <div className="welcome-admin">
        <p>Wybierz z menu interesującą cię kategorię.</p>
      </div>
    </div>
  );
}
